import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteVideoConfig, getVideoConfig, getVideoConfigId } from '../../actions/videoСonfig'
import { getRoomsList } from '../../actions/rooms'
import { SET_VIDEO_CONFIG_ID } from '../../actions/types'


export default function VideoConfig() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { videoConfigList, videoConfig } = useSelector(state => state.video_config)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getVideoConfig())
  }, [])

  const openModal = (data) => () => {
    data && dispatch(getVideoConfigId(data.camid))
    setSelectedItem(data || {})
    dispatch(getRoomsList())
  }

  const closeModal = () => {
    dispatch({ type: SET_VIDEO_CONFIG_ID, payload: [] }); // переделать красивее
    setSelectedItem(null)
  }

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteVideoConfig(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { camid, name, description, enabled, dnevnik } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{name}</td>
        <td onClick={openModal(data)}>{description}</td>
        <td onClick={openModal(data)}>{enabled ? 'Да' : 'Нет'}</td>
        <td onClick={openModal(data)}>{dnevnik ? 'Да' : 'Нет'}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: camid, name: name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          // addMode={(!selectedItem?.name && selectedItem !== null)}
          addMode={!selectedItem.name}
        />
      }
      <h1>Видеокамеры</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Кабинет</th>
            <th>Описание</th>
            <th>Активна</th>
            <th>Транслировать в эл.дневник</th>
            <th></th>
          </tr>
        </thead>
        <tbody>

          {videoConfigList?.map(renderLi)}

        </tbody>
      </Table>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
